<template>
  <v-dialog :value="value" width="400" persistent>
    <v-card>
      <v-card-title>Move to a new account</v-card-title>

      <v-card-text>

        <v-row>
          <v-col>
            <p><b>
              This will move the product to a new billing account. <br> 
              The billing account details will be copied from the current billing account.
            </b></p>
          </v-col>
        </v-row>


      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submit" :disabled="disableOK" :loading="getMoveToNewAccountLoading">OK</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getMoveToNewAccountLoading">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions,mapGetters,mapMutations } from 'vuex';

  const URL = process.env.VUE_APP_URL || `https://crm-bonline-testing.appspot.com/`;

  export default {

    props: ['value'],

    computed: {
      ...mapGetters('moveToAccount',['getMoveToNewAccountProductId','getMoveToNewAccount','getMoveToNewAccountLoading','getMoveToNewAccountError']),

      disableOK(){
        return this.getMoveToNewAccountLoading;
      },
    },

    methods: {
      ...mapActions('moveToAccount',['MOVE_TO_NEW_ACCOUNT']),
      ...mapActions('alerts', ['setAlert']),
      ...mapMutations('moveToAccount',['RESET_MOVE_TO_STORE']),

      async submit() {
        await this.MOVE_TO_NEW_ACCOUNT();

        if(!this.getMoveToNewAccountError){
          window.open(`${URL}accounts/${this.getMoveToNewAccount.id}/`);
          // Snackbar to be used when we refactor the account page to use a proper store
          // this.setAlert({type: 'success', message: `${this.getMoveToNewAccountProductId} product has been moved to a new account: ${this.getMoveToNewAccount.id}`});
          window.location.reload();
          this.close();
        }
      },

      close() {
        this.RESET_MOVE_TO_STORE();
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
